import { useFormContext } from "react-hook-form";
import { RSVPStepsFormInputData } from "../validators";
import { useEffect } from "react";
import { getRSVPStepsAndPageData } from "../actions/rsvp-steps-and-data";
import MembersOnlyRSVPCountdown from "~/components/v3/events-components/MembersOnlyRSVPCountdown";
import { CustomizableLayout } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";

const JoinWaitlistStep = ({
    setIsNextDisabled,
    eventInfo,
    customization,
}: {
    setIsNextDisabled: (disabled: boolean) => void;
    eventInfo: Awaited<ReturnType<typeof getRSVPStepsAndPageData>>["eventInfo"];
    customization?: CustomizableLayout;
}) => {
    const form = useFormContext<RSVPStepsFormInputData>();

    useEffect(() => {
        const isFormValid =
            form.formState.isValid && form.watch("joinWaitlist") === true;

        setIsNextDisabled(!isFormValid);
    }, [form.formState.isValid, form.watch("joinWaitlist"), setIsNextDisabled]);

    if (eventInfo.event?.isInMembersOnlyRSVPPeriod) {
        return (
            <div className="flex flex-col items-start gap-4">
                <p className={cn(customization?.descriptionClassName)}>
                    This event is currently in its members-only RSVP period.
                    Would you like to join the waitlist and be notified when
                    general RSVP opens?
                </p>
                <div
                    className={cn(
                        "flex items-center gap-2 text-white",
                        customization?.descriptionClassName,
                    )}
                >
                    <>
                        I understand that I'll be added to the waitlist until
                        the members-only period ends, and my spot isn't
                        guaranteed.
                        <input
                            type="checkbox"
                            {...form.register("joinWaitlist")}
                        />
                    </>
                </div>
                <MembersOnlyRSVPCountdown event={eventInfo.event} />
            </div>
        );
    }

    return (
        <div className="flex flex-col items-start gap-4">
            <p className={cn(customization?.descriptionClassName)}>
                This event is currently full, do you want to join waitlist?
            </p>
            <div
                className={cn(
                    "flex items-center gap-2 text-white",
                    customization?.descriptionClassName,
                )}
            >
                I understand that I'm requesting to join the waitlist and
                there's no guarantee that the host will accept my request.
                <input type="checkbox" {...form.register("joinWaitlist")} />
            </div>
        </div>
    );
};

export default JoinWaitlistStep;
